<template>
  <div class="darkbg"></div>
  <div class="loginpage mobile-modal-takeover" v-if="!loginsuccess">
    <div class="log-box">
      <div class="e-log-box">
        <!--  <div class="block pc_field">
          <div class="row childcenter">
            <div class="left_c childcenter" style="width: 10%" @click="closeWin()">
              <img src="@/assets/images/ljt.png" style="height: 18px; width: 18px" />

              <span
                @click="changePage('login')"
                style="margin-left: 0px; cursor: pointer;font-size:15px; border: 0px solid red"
                >Back</span
              >
            </div>
            <div class="left_c title" style="justify-content: center; width: 80%">
            Recover Your Password</div>
            <div class="right_c title" style="width: 10%" @click="closeWin()">X</div>
          </div>
        </div> -->


        <div class="block">
          <div class="row" style="flex-direction:row;">
            <div class="left_c title" style="justify-content: left; width: 90%">
              {{t('recover.recoverYourPassword')}}
              
            </div>
            <div class="right_c title" style="width: 10%" @click="closeWinMe()" v-if="hideClose != 1">
              <img src="/images/icon_close.png" style="width: 19px; height: 19px; object-fit: cover" />
            </div>
          </div>
        </div>

        <!--    <div class="block">
          <div class="row" style="flex-direction:column;">
            <div class="left_c title" style="justify-content: center; width: 100%">
              Recover Your Password
            </div>
            <div class="childcenter" style="width: 100%; padding-top: 25px">
              <img
                src="@/assets/images/recoverpass.png"
                style="width: 50px; height: 50px; object-fit: cover"
              />
            </div>
          </div>
        </div> -->

        <div class="row content" style="padding-bottom: 25px">
          {{t('recover.desc')}}
          
        </div>
        <el-form ref="rieForms" label-position="top" label-width="auto" autocomplete="off" :model="loginForm">
          <div class="tab-box">
            <div class="tab-name" style="width: 100%"><span class="star">*</span> {{t('common.emailAddress')}}</div>
          </div>
          <el-form-item label="" style="width: 100%; " prop="email">
            <el-input v-model="email" :placeholder="t('common.email')"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="error != ''" class="error">{{ error }}</div>
      <div v-if="success != ''" class="success">{{ success }}</div>

      <div class="btn-box" @click="RecovermyPassword">{{t('recover.recoverMyPassword')}}</div>
    </div>


  </div>
  <div v-else>
    <AlertDialog @closeWin="closeWin()" status="success" title="" :content="t('recover.successDesc')" />
  </div>
</template>
<script>
import Request from '@/services/Request'
import AlertDialog from '@/components/alertdialog.vue'
import '@/assets/main.css'
import { useUserStore } from '@/stores/UserStore'
import { useI18n } from 'vue-i18n';
export default {
  components: { AlertDialog },
  emits: ['changePage'],
  props: ['hideClose'],
  data() {
    return {
      email: '',
      loginForm: {},
      error: '',
      success: '',
      loginsuccess: false
    }
  },
  setup() {

    const { t, locale } = useI18n();
    const userStore = useUserStore()
    const user = userStore.user;


    return { userStore, user, t, locale }
  },
  created() { },
  methods: {
    closeWinMe() {

      // this.userStore.showLoginDlg = 'login'

      this.$emit('close')
      this.$emit('changePage', "login")
    },
    changePage(page) {
      if (page == "") {
        this.userStore.showLoginDlg = ''
      }


      this.$emit('changePage', page)
    },
    closeWin() {

      this.$emit('close') // 当点击关闭按钮时，触发close事件
      this.changePage("login");
    },


    needfields() {
      return '' != this.rieForm.firstname && '' != this.rieForm.telephone
    },
    onFinish() {
      this.showBtn = true
    },

    parseQueryString(url) {
      const queryString = url.split('?')[1]
      const params = {}
      if (queryString) {
        queryString.split('&').forEach((pair) => {
          var [key, value] = pair.split('=')
          key = key == 'route' ? 'url' : key
          params[decodeURIComponent(key)] = decodeURIComponent(value)
        })
      }
      return params
    },
    RecovermyPassword() {

      this.error = ''
      this.success = ''
      this.submited = true
      if (this.email == '') {
        this.error = this.t('recover.enterEmail');

        return
      }
      new Request().webPost(
        { email: this.email },
        (res) => {
          //console.log(res)
          if (res.hasOwnProperty('error_warning')) this.error += res.error_warning

          if (this.error == '') {
            // this.submited = false
            // this.loginForm.email = this.email
            this.loginsuccess = true;
            // this.$emit('changePage', 'login')
          }
          // this.isforgotPassword = 0;
          // this.loginBtnTitle = 'Log In';
        },
        'account/forgotten'
      )
    },
    formvalidater() {
      return new Promise((resolve, reject) => {
        this.$refs.rieForms.validate((valid) => {
          if (!valid) {
            resolve(false) // 或者使用 reject() 来表示验证失败
          } else {
            resolve(true)
          }
        })
      })
    },


  }
}
</script>



<style lang="scss" scoped>
.title {
  font-size: 17px;
  font-weight: bold;
}

.checkbox {
  background: #fff;
  width: 16px;
  height: 16px;
  border: 1px #ccc solid;
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.4083rem;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.agree {
  background: #4F6F52;
  border: 1px #4F6F52 solid;
  font-size: 1.4083rem;
}

.noagree {
  background: #fff;
  border: 1px #4F6F52 solid;
}

.red-placeholder ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: red !important;
  opacity: 1;
  /* Firefox */
}

.red-placeholder :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red !important;
}

.red-placeholder ::-ms-input-placeholder {
  /* Microsoft Edge */
  color: red !important;
}

.el-divider--horizontal {
  width: 60% !important;
  margin: 0 auto;
}

.log-success-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 813rpx;
  height: 782rpx;
  flex-shrink: 0;
  border-radius: 33px;
  border-radius: 33px;
  background: #fff;
  z-index: 99;
}

:deel(.el-dialog) {
  top: -75px;
  border-radius: 33px;

  .el-dialog__header {
    font-weight: bold;
    border: 0px solid red;
    padding-top: 30px;
    text-align: center;

    .el-dialog__headerbtn {
      font-size: 2.8167rem;
      font-weight: 700;
      color: #000;
    }
  }
}

* {
  padding: 0;
}

.el-select-dropdown__item {
  padding: 0 20px;
}

.log-box {
  margin-top: 0rpx;
  padding: 10px 15px;

  .yy-box {
    text-align: center;
    margin-top: 8px;

    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #a6a6a6;

    span {
      color: rgba(255, 87, 34, 1);
      cursor: pointer;
    }
  }

  .btn-box {

    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    width: 90%;
    height: 5.4rem !important;
    background: rgba(0, 241, 189, 0.5);

    border-radius: 8px;
    opacity: 1;
    font-size: 1.3333rem;
    font-family: Poppins;
    font-weight: bold;

    cursor: pointer;
    text-align: center;
    float: none;
    margin-top: 11px;

  }

  .forgrt-box {
    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #4F6F52;
    cursor: pointer;
    margin-top: 10px;

    :deel(.el-checkbox) {
      .el-checkbox__inner {
        height: 16px;
        width: 16px;
        border-color: #aaa;

        border-radius: 2px;
      }

      .el-checkbox__input.is-checked .el-checkbox1__inner {
        background-color: #4F6F52;
        border-color: #aaa;
      }

      .el-checkbox__inner:hover {
        border-color: #aaa;
      }

      .el-checkbox__inner::after {
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1.2) rotate(45deg);
      }
    }

    /**/

    div {
      font-size: 1.4083rem;
      margin-left: 10px;
    }
  }

  :deep(.e-log-box) {

    .el-form {
      .el-form-item {
        vertical-align: middle;
        width: 50%;
        margin: 0;
        padding: 15px 0px;
        border: 0px solid red;

        padding-right: 10px;

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          width: 100%;

          .el-date-editor--date {
            width: 100%;
          }

          .el-select {
            width: 100%;
          }

          .input-with-select {
            border: 2rpx solid #e9e9eb;
            border-radius: 45px;
            padding: 8rpx 7px 4px 0;

            &.el-input .el-input__inner {
              border: none;
              height: 40px;
              line-height: 40px;
              padding-left: 10px;

              &::placeholder {
                color: #cfcfcf;
              }
            }

            .el-input-group__append {
              border-radius: 20rpx;
              font-weight: bold;
              cursor: pointer;
            }
          }

          .el-input {
            .el-input__inner {
              height: 35px;
              line-height: 35px;
              color: #333;
              border-radius: 10px;
              border: 0px solid red;
              background: #f5f5f5;
              padding-left: 10px;

              &::placeholder {
                color: #a6a6a6;
              }
            }

            .el-input__suffix .el-input__icon.el-icon-arrow-up {
              color: #333;
            }
          }
        }
      }

      .el-input-group__append {
        background: #4F6F52;
        border: 1px solid #4F6F52;
      }
    }
  }

  .tab-box {
    padding-bottom: 6px;
    padding-left: 9px;
    width: 100%;
    float: left;

    .star {
      color: #4F6F52;
      padding-right: 5px;
    }

    .active {
      color: #4F6F52 !important;
    }

    .tab-name {
      font-size: 1.4083rem;
      font-family: Poppins;
      font-weight: 400;
      color: #333333;
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.fb-btn {
  display: flex;
  margin-bottom: 10px;
  padding: 0 25px;

  div {
    flex: 1;
    height: 40px;
    border-radius: 25px;
    opacity: 1;
    border: 2px solid #a6a6a6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #333333;
    cursor: pointer;

    &:first-child {
      margin-right: 10px;
    }
  }
}

.primaryColor {
  color: #4F6F52;
}

.custom-checkbox .el-checkbox__inner {
  border-color: #4F6F52 !important;
}

/* 当checkbox被hover时也改变边框颜色 */
.custom-checkbox:hover .el-checkbox__inner {
  border-color: #4F6F52 !important;
}

/* 当checkbox被选中时，改变对号的颜色以适应新的边框颜色 */
.custom-checkbox.is-checked .el-checkbox__inner {
  border-color: #4F6F52 !important;
}

.custom-checkbox.is-checked .el-checkbox__inner::after {
  border-color: #4F6F52 !important;
}

:deel(.el-cascader-node.in-active-path),
:deel(.el-cascader-node.is-active),
:deel(.el-cascader-node.is-selectable.in-checked-path) {
  color: #4F6F52;
}

:deel(.el-dropdown-menu__item) {
  padding: 10rpx 20rpx;

  text-align: center;
}

:deel(.share-adventure-wrap) {
  background-color: red;
}

:deel(.el-dropdown-menu__item:hover) {
  background-color: #4F6F52;
  color: #fff;
}

:deel(.el-dropdown-menu__item:focus) {
  background-color: #4F6F52;
  color: #fff;
}

:deel(.el-dropdown-menu) {
  padding: 0 !important;
}

.el-dropdown-menu {
  padding: 0 !important;
  border-radius: 15px;
  text-align: center;
  overflow: hidden;
}

.loginpage {
  position: fixed;
  width: 450px;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 25px;
  z-index: 99;
  background: #fff;
  padding: 15px;
  font-size: 1.4083rem;
}

.country-item {
  display: flex;
  align-items: center;

  .country-img {
    width: 20rpx;
    height: 20rpx;
  }

  .country-txt {
    font-size: 1.1917rem;
    margin-left: 3px;
  }
}

:deep(.pc_field) {
  display: block;
}

:deep(.m_field) {
  display: none;
}
</style>



<!-- 移动端 -->
<style scoped>
@media screen and (max-width: 750px) {
  .title {
    font-size: 1.4rem;
  }

  .content {
    font-size: 1.2rem;
  }

  :deep(.pc_field) {
    display: none;
  }

  :deep(.m_field) {
    display: block;
  }


  .loginpage {
    position: fixed;
    width: 390px;
    top: 170px;

  }

  :deep(.log-box .btn-box) {


    height: 3.4rem !important;


  }


  :deep(.el-date-editor.el-input),
  .el-date-editor.el-input__wrapper {
    height: 30px !important;
    font-size: 1.4083rem;
    width: 100% !important;
  }

  html,
  body {
    line-height: 25px !important;
  }
}
</style>